'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Unlock = require('./Unlock');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Unlock).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-icons/lib/components/Unlock/index.js
// module id = 1310
// module chunks = 1